import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Classes, Events, tcVarName } from '../global/constants';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Content Sections ----------

	$('.hero-section').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const content = this.querySelector(':scope .section-content');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top top',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => '0svh', ease: 'none' },
					{ y: () => '-10svh', ease: 'none' }
				);

				if(content) {

					timeline.fromTo(
						content,
						{ y: () => '0svh', ease: 'none' },
						{ y: () => '90svh', ease: 'none' },
						0
					)
				}
			}
		});
	});

	$('.introduction-section, .entity-introduction-section, .medias-links-section, .contact-section').each(function() {

		Animations.mobile.min.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: 'top bottom-=65px',
					end: '+=25%',
					scrub: true,
					invalidateOnRefresh: true,
				},
			});

			timeline.fromTo(this,
				{
					[tcVarName('animation-offset')]: () => '4vw',
					ease: 'none'
				},
				{
					[tcVarName('animation-offset')]: () => '0vw',
					ease: 'none'
				}
			);
		});
	});

	$('.parallax-section:not(.hero-section):not(.fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: (this.classList.contains('parallax-header')) ? 'top top' : 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => (this.classList.contains('parallax-header')) ? 0 : offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Menu ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					end: 'max',
					onUpdate: (self) => {
						(self.direction === -1) ? this.classList.remove(Classes.shrink) : this.classList.add(Classes.shrink);
						(self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
					}
				}
			});
		});
	});
};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
